import invariant from 'invariant';
import { GIGYA_BRAND_IMAGE_FAVORITES } from 'globalConst/gigya-const';
import * as analytics from 'analytics';
import { navigateToLoginScreen } from 'actions/gigya-router-actions';
import { showNotification } from 'actions/notifications-actions';
import { NotificationTypes, NotificationTexts } from '../components/Notifications/Notification';
import { favoriteTrackActions } from './actions-const';
import logger from 'util/logger';

function favoriteTrack(signature, track) {
  return async (dispatch, getState) => {
    const {
      favorites,
      player: { currentStation },
      user: { isLoggedIn },
    } = getState();

    // optimistic UI
    const dispatchType = isLoggedIn ? favoriteTrackActions.FAVORITE_TRACK : favoriteTrackActions.QUEUE_FAVORITE_TRACK;

    dispatch({
      type: dispatchType,
      payload: {
        ...track,
        updatedAt: Date.now(),
      },
    });

    if (isLoggedIn) {
      try {
        dispatch(
          showNotification({
            message: NotificationTexts.TRACK_ADD_TO_COLLECTION,
          })
        );

        analytics.trackFavoriteTrack(track, currentStation);
      } catch (e) {
        // rollback
        dispatch({
          type: favoriteTrackActions.ROLLBACK_FAVORITES,
          payload: favorites,
        });

        dispatch(
          showNotification({
            message: NotificationTexts.TRACK_ADD_TO_COLLECTION_ERROR,
            type: NotificationTypes.ERROR,
          })
        );
        logger.error(e);
      }
    }
  };
}

function unfavoriteTrack(signature, track) {
  return async (dispatch, getState) => {
    const {
      favorites,
      player: { currentStation },
    } = getState();
    // optimistic UI
    dispatch({
      type: favoriteTrackActions.UNFAVORITE_TRACK,
      payload: track.isrc,
    });
    try {
      dispatch(
        showNotification({
          message: NotificationTexts.TRACK_REMOVE_FROM_COLLECTION,
        })
      );

      analytics.trackUnfavoriteTrack(track, currentStation);
    } catch (e) {
      // rollback
      dispatch({
        type: favoriteTrackActions.ROLLBACK_FAVORITES,
        payload: favorites,
      });

      dispatch(
        showNotification({
          message: NotificationTexts.TRACK_REMOVE_FROM_COLLECTION_ERROR,
          type: NotificationTypes.ERROR,
        })
      );
      logger.error(e);
    }
  };
}

export function favoriteTrackToggle(track) {
  return async (dispatch, getState) => {
    const {
      favorites: { tracks: currentFavoriteTracks },
      user: { isLoggedIn, signature },
    } = getState();

    if (!isLoggedIn) {
      analytics.gigyaExpand('add-my-category');
      navigateToLoginScreen(GIGYA_BRAND_IMAGE_FAVORITES);
    } else {
      invariant(signature, 'No signature found.');
    }

    const isFavorite = currentFavoriteTracks.some((favorite) => favorite.isrc === track.isrc);

    if (isFavorite) {
      dispatch(unfavoriteTrack(signature, track));
    } else {
      dispatch(favoriteTrack(signature, track));
    }
  };
}

export function loadQueuedFavoriteTracks() {
  return async (dispatch, getState) => {
    const {
      favorites,
      user: { isLoggedIn },
    } = getState();

    if (!isLoggedIn) {
      return;
    }

    const queuedTracks = favorites.queue.tracks;

    await Promise.all(
      queuedTracks.map(async (track) => {
        try {
          dispatch({
            type: favoriteTrackActions.FAVORITE_TRACK,
            payload: track,
          });

          dispatch(
            showNotification({
              message: NotificationTexts.TRACK_ADD_TO_COLLECTION,
            })
          );
        } catch (e) {
          // rollback
          dispatch({ type: favoriteTrackActions.ROLLBACK_FAVORITES, payload: favorites });

          dispatch(
            showNotification({
              message: NotificationTexts.TRACK_ADD_TO_COLLECTION_ERROR,
              type: NotificationTypes.ERROR,
            })
          );
          logger.error(e);
        }
      })
    );
  };
}
